module.exports = __webpack_public_path__ + "img/tcp-logo.28d501dc.png";